import Vuex from "vuex";
import userVUEX from "./modules/userVUEX.js";
import cvSearchVUEX from "./modules/cvSearchVUEX.js";
import customerVUEX from "./modules/customerVUEX.js";
import vendorVUEX from "./modules/vendorVUEX.js";
import jobDescriptionVUEX from "./modules/jobDescriptionVUEX.js";
import panelVUEX from "./modules/panelVUEX.js";
import accessControlVUEX from "./modules/accessControlVUEX.js";
import permission from "./modules/permission.js";
import hrPortalReferenceVUEX from "./modules/hrPortalReferenceVUEX.js";
import scheduleInterviewVUEX from "./modules/scheduleInterviewVUEX.js";
import getters from "./getters";
import searchVUEX from "./modules/searchVUEX.js";
import teamsVUEX from "./modules/teamsVUEX.js";
import folderVUEX from "./modules/folderVUEX.js";

export default new Vuex.Store({
  modules: {
    userVUEX,
    customerVUEX,
    jobDescriptionVUEX,
    vendorVUEX,
    panelVUEX,
    scheduleInterviewVUEX,
    accessControlVUEX,
    permission,
    hrPortalReferenceVUEX,
    searchVUEX,
    teamsVUEX,
    cvSearchVUEX,
    folderVUEX,
  },
  getters,
});
